<template>
    <div class="bxs-spacer">
    </div>
</template>

<script>
export default {
    name: 'bxs-spacer'
}
</script>